export const environment = {
  production: true,
  // apiURL: "http://127.0.0.1:8000/api",
  apiURL: "https://blog.dentalchat.com/server/api",
  siteUrl: "https://dentalchat.com",
  chatImageApiPath: "https://blog.dentalchat.com/server",
  chatImagePath: "https://blog.dentalchat.com/server",
  chatImageuploadApiPath: "https://socket.dentalchat.com",
  OauthUrl: "https://epic-staging.easyparksystem.net/epic-rest/oauth/token",
  username: "nevaventures",
  password: "m3AeSvqdF9xa",
  authToken: "z7NHOmfvqRPAoKM",
  firebaseConfig: {
    apiKey: "AIzaSyBZwAqI09ImIq084zpoOcJ6S2lWEZgoDos",
    authDomain: "dentalchat-60cc6.firebaseapp.com",
    databaseURL: "https://dentalchat-60cc6-default-rtdb.firebaseio.com",
    projectId: "dentalchat-60cc6",
    storageBucket: "dentalchat-60cc6.appspot.com",
    messagingSenderId: "217822035698",
    appId: "1:217822035698:web:a718c2bec3917b8ef49a6b",
    measurementId: "G-5SX1KVC700"
  },
  ProjectSecretToken: "db4a4815-3ed0-4945-bba8-b8b75ac0ef93",
  apiUrlTeleDental: "https://tele.dentalchat.com/api",
  teleDentalHostURL: "https://tele.dentalchat.com"
};